module.exports = __webpack_public_path__ + "static/img/univerzitet_modernih_znanosti_mostar.19ab898.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/univerzitet_modernih_znanosti_mostar.jpg
// module id = FZDL
// module chunks = 0